module.exports = __webpack_public_path__ + "img/T4-D-xs_20.4ca71f6c.png";